import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { SectionItem } from '../../../Section'
import InputWithLimit from 'components/Customize/InputWithLimit'
import { Messages } from '../../constants'

import style from './style'

const MessageInputs = ({ intl, welcomeMessage, awayMessage, onWelcomeMessageChanged, onAwayMessageChanged }) => (
  <div className={style.MessageInputsWrapper}>
    <div className="message-inputs">
      <InputWithLimit
        title="Online Message"
        text={welcomeMessage}
        placeholder={intl.formatMessage(Messages.defaultWelcomeMessage)}
        maxLength={140}
        invalidLabel="You have entered too many characters"
        onChange={onWelcomeMessageChanged}
        className="message-input"
      />
      <InputWithLimit
        title="Offline Message"
        text={awayMessage}
        placeholder={intl.formatMessage(Messages.defaultAwayMessage)}
        maxLength={164}
        invalidLabel="You have entered too many characters"
        onChange={onAwayMessageChanged}
        className="message-input"
      />
    </div>
  </div>
)

export default injectIntl(MessageInputs)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/WelcomeMessage/components/MessageInputs/index.js